<template>
<div>
  <child-scroll :data='scrollList' :parentEvent="tabList(item)"/>
</div>
</template>

<script>
  import ChildScroll from './htm.vue'
  export default {
    name: "scrollParent.vue",
    components: {
      ChildScroll,
    },
    data(){
      return {
      }
    },
    methods:{
      tabList(item){
        console.log(item)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/parent.vue